export let signStatus = [
  {
    label: '待支付',
    value: 'WAIT_FOR_PAY'
  },
  {
    label: '已预约',
    value: 'SUCCESS'
  },
  {
    label: '已取消',
    value: 'CANCEL'
  }
]

// 证件类型枚举
export let identityCardType = [
  {
    label: '身份证',
    value: 'CHINESE_IDENTITY_CARD'
  },
  {
    label: '护照',
    value: 'PASSPORT'
  },
  {
    label: '军官证',
    value: 'MILITARY_ID'
  }
]
// 生命银行体验馆新状态枚举
export let workflowHallStatus = [
  {
    label: '待确认',
    value: 'UNCONFIRMED'
  },
  {
    label: '已确认',
    value: 'CONFIRMED'
  },
  {
    label: '已打卡',
    value: 'SIGNED_IN'
  }
]
// 预约生命体验馆状态枚举
export let hallStatus = [
  {
    label: '已取消',
    value: 'CANCEL'
  }
]
// 报告预约解读新状态枚举
export let reportReadStatus = [
  {
    label: '待确认',
    value: 'UNCONFIRMED'
  },
  {
    label: '已确认',
    value: 'CONFIRMED'
  },
  {
    label: '已解读',
    value: 'INTERPRETED'
  },
  {
    label: '已失效',
    value: 'INVALID'
  },
  {
    label: '多次致电未接通',
    value: 'PHONE_CAN_NOT_GET_THROUGH'
  },
  {
    label: '其他原因取消',
    value: 'OTHER_REASON_CANCEL'
  }
]
// 报告解读原始状态枚举
export let reportStatus = [
  {
    label: '已预约',
    value: 'SUCCESS'
  },
  {
    label: '已取消',
    value: 'CANCEL'
  }
]
// 问卷调查状态枚举
export let questionStatus = [
  {
    label: '已提交',
    value: 'SUCCESS'
  },
  {
    label: '已取消',
    value: 'CANCEL'
  }
]
// 预约解读重购意向
export let purchaseIntentionMode = [
  {
    label: '无',
    value: 'NONE'
  },
  {
    label: '一般',
    value: 'NORMAL'
  },
  {
    label: '强烈',
    value: 'INTENSE'
  },
  {
    label: '已成单',
    value: 'PLACE_ORDER'
  }
]
// 报告预约解读状态变更
export let changeStatusMode = [
  {
    label: '多次致电未接通',
    value: 'setStatusPhoneNot'
  },
  {
    label: '其他原因取消',
    value: 'setStatusOtherReason'
  }
]
